import React from "react";
import useFetchData from "./FetchData";
import { useNavigate } from "react-router-dom";
import {
  GET_TECHNICALDEPUTY_APPROOVEREQUESTWORK,
  GET_TECHNICALDEPUTY_FINISHREQUESTWORK,
} from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import moment from "moment-jalaali";

function getParameterByName(name: any, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const api = new APIClient();

const TableRequestWork = () => {
  let x = 1;
  let projectId;
  projectId = getParameterByName("projectId");
  let { data, loading } = useFetchData(projectId);

  const history = useNavigate();

  const handleNavigationToWorkOfRequestWork = (id: any) => {
    history(`/TechnicalDeputy/requestwork/listofwork?reqWorkId=${id}`);
  };

  const handleNavigationToMemberOfRequestWork = (id: any) => {
    history(`/TechnicalDeputy/requestwork/listofmember?reqWorkId=${id}`);
  };

  const handleApproveRequestWork = (id: any) => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_TECHNICALDEPUTY_APPROOVEREQUESTWORK, { requeseWorkId: id })
          .then(() => {
            window.location.reload();
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  };

  const handleFinishRequestWork = (id: any) => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_TECHNICALDEPUTY_FINISHREQUESTWORK, { requestWorkId: id })
          .then(() => {
            window.location.reload();
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  };

  if (loading) return <p>loading ...</p>;
  return (
    <React.Fragment>
      <div className="card">
        <div className="card-body">
          <h6 className="mb-12 text-15">
            جبهه‌های کاری پروژه کد شماره{" "}
            {data.reqWorks[0].projectCode !== undefined
              ? data.reqWorks[0].projectCode
              : ""}
          </h6>

          <div className="overflow-x-auto">
            <table className="w-full bg-custom-50 dark:bg-custom-500/10">
              <thead className="ltr:text-left rtl:text-right bg-custom-100 dark:bg-custom-500/10">
                <tr>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    ردیف
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    تاریخ
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    جمع کل
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    یادداشت
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    مدیر اجرا
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    معاون فنی
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    سرتیم
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    وضعیت پایان
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <tr> */}
                {!loading &&
                  data.reqWorks.map((reqWork) => (
                    <tr key={reqWork.id}>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        <a
                          href="#!" // Use downloadLink if available, otherwise fallback to "#"
                          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
                        >
                          {x++}
                        </a>
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork && reqWork.date
                          ? moment(reqWork.date, "YYYY-MM-DD").format(
                              "jYYYY/jMM/jDD"
                            )
                          : "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {new Intl.NumberFormat("en-US").format(
                          reqWork.wholeAmount
                        ) || "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork.note || "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork.projectManagerName || "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork.approvedByTechnicalDeputy ? (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-custom-500 border-custom-500 text-custom-50">
                            Approved
                          </span>
                        ) : (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-red-500 border-red-500 text-red-50">
                            Not Approved
                          </span>
                        )}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork.approvedByTeamHead ? (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-custom-500 border-custom-500 text-custom-50">
                            Approved
                          </span>
                        ) : (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-red-500 border-red-500 text-red-50">
                            Not Approved
                          </span>
                        )}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {reqWork.finished ? (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-custom-500 border-custom-500 text-custom-50">
                            Finished
                          </span>
                        ) : (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-red-500 border-red-500 text-red-50">
                            Not Finished
                          </span>
                        )}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {!reqWork.approvedByTechnicalDeputy ? (
                          <button
                            style={{
                              display: "inline-block",
                              backgroundColor: "green",
                              color: "white",
                              padding: "10px 20px 10px",
                              border: "none",
                              marginRight: "3px",
                              marginTop: "3px",
                            }}
                            onClick={() => handleApproveRequestWork(reqWork.id)}
                            className="btn btn-primary"
                          >
                            تایید
                          </button>
                        ) : (
                          ""
                        )}

                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "grey",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() =>
                            handleNavigationToMemberOfRequestWork(reqWork.id)
                          }
                          className="btn btn-primary"
                        >
                          اعضا
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "grey",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() =>
                            handleNavigationToWorkOfRequestWork(reqWork.id)
                          }
                          className="btn btn-primary"
                        >
                          کارها
                        </button>
                        {!reqWork.finished ? (
                          <button
                            style={{
                              display: "inline-block",
                              backgroundColor: "red",
                              color: "white",
                              padding: "10px 20px 10px",
                              border: "none",
                              marginRight: "3px",
                              marginTop: "3px",
                            }}
                            onClick={() => handleFinishRequestWork(reqWork.id)}
                            className="btn btn-primary"
                          >
                            پایان
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TableRequestWork;
